define('common',["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.emitChanges = emitChanges;
  _exports.formatNumber = formatNumber;
  _exports.formatPrice = formatPrice;
  _exports.getJSON = getJSON;
  _exports.isAddressBarToggled = isAddressBarToggled;
  _exports.isMobile = isMobile;
  _exports.parseArray = parseArray;
  _exports.parseBookParams = parseBookParams;
  _exports.parseBounds = parseBounds;
  _exports.parseInteger = parseInteger;
  _exports.parseIntegerArray = parseIntegerArray;
  _exports.parseRange = parseRange;
  _exports.postJSON = postJSON;
  _exports.slideTo = slideTo;
  _exports.stringifyArray = stringifyArray;
  _exports.stringifyBounds = stringifyBounds;
  _exports.stringifyDateRange = stringifyDateRange;
  _exports.stringifyRange = stringifyRange;
  function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a, u = !0; return { s: function s() { t = t.call(r); }, n: function n() { u = !0; var r = t.next(); return r.done ? { done: !0 } : { value: r.value, done: u = !1 }; }, e: function e(r) { o = !0, a = r; }, f: function f() { try { u || null == t.return || t.return(); } finally { if (o) throw a; } } }; }
  function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
  function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  function createEvent(type, bubbles = true) {
    return new Event(type, {
      bubbles
    });
  }
  function emitChanges(el) {
    var _iterator = _createForOfIteratorHelper(el.querySelectorAll('input, select, textarea')),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var input = _step.value;
        if (['text', 'email', 'tel', 'date', 'time', 'select-one', 'textarea'].includes(input.type) && !input.readOnly) {
          if (input.value) {
            input.dispatchEvent(createEvent('input', true));
            input.dispatchEvent(createEvent('change', true));
          }
        }
        if (['radio', 'checkbox'].includes(input.type) && !input.readOnly) {
          if (input.checked) {
            input.dispatchEvent(createEvent('change', true));
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  function formatNumber(value) {
    return value.toLocaleString(GA.lcNumeric, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: value >= 10000
    });
  }
  function formatPrice(value, currency = GA.currency()) {
    return value.toLocaleString(GA.lcNumeric, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: value >= 10000
    });
  }
  function isAddressBarToggled(height) {
    return isMobileChrome() && Math.abs(height - innerHeight) < 128;
  }
  function isAndroid() {
    return !!navigator.userAgent.match(/Android/i);
  }
  function isBlackBerry() {
    return !!navigator.userAgent.match(/BlackBerry/i);
  }
  function isIOS() {
    return !!navigator.userAgent.match(/(Pad|Phone|Pod)/i);
  }
  function isMobile() {
    return isAndroid() || isIOS() || isOpera() || isWindows() || isBlackBerry();
  }
  function isMobileChrome() {
    return !!(navigator.userAgent.match('CriOS') || navigator.userAgent.match('Android.+Chrome') || isIOS());
  }
  function isOpera() {
    return !!navigator.userAgent.match(/Opera Mini/i);
  }
  function isWindows() {
    return !!navigator.userAgent.match(/IEMobile/i);
  }
  function parseArray(v) {
    if (Array.isArray(v)) {
      return v;
    } else if (typeof v === 'string' && v.includes(',')) {
      return v.split(',');
    } else if (v) {
      return [v];
    } else {
      return null;
    }
  }
  function stringifyArray(array) {
    return array ? array.join(',') : null;
  }
  function parseInteger(v) {
    var num = Number.parseInt(v, 10);
    return Number.isFinite(num) ? num : null;
  }
  function parseIntegerArray(v) {
    var arr = parseArray(v);
    if (Array.isArray(arr)) {
      return arr.map(parseInteger).filter(n => n !== null);
    }
    return null;
  }
  function parseBounds(str) {
    if (typeof str === 'string') {
      var parts = str.split(',').map(Number.parseFloat);
      if (parts.length === 4 && parts.every(Number.isFinite)) {
        return {
          west: parts[0],
          south: parts[1],
          east: parts[2],
          north: parts[3]
        };
      }
    }
    return null;
  }
  function stringifyBounds(bounds) {
    return bounds ? [bounds.west, bounds.south, bounds.east, bounds.north].map(String).join(',') : null;
  }
  function parseRange(str) {
    if (typeof str === 'string' && str.length > 0) {
      var match = str.match(/^((\d+)-)?(\d+)?$/);
      if (match) {
        var range = {};
        if (match[2]) {
          var _parseInteger;
          range.start = (_parseInteger = parseInteger(match[2])) !== null && _parseInteger !== void 0 ? _parseInteger : undefined;
        }
        if (match[3]) {
          var _parseInteger2;
          range.end = (_parseInteger2 = parseInteger(match[3])) !== null && _parseInteger2 !== void 0 ? _parseInteger2 : undefined;
        }
        return range;
      }
    }
    return null;
  }
  function stringifyRange(range) {
    return range ? (range.start ? `${range.start}-` : '') + (range.end || '') : null;
  }
  function parseDateRange(str) {
    if (typeof str === 'string' && str.length > 0) {
      var parts = str.split(/[~/]/);
      var start = parts[0];
      var end = parts[1];
      var range = {};
      if (start) {
        range.start = start;
      }
      if (end) {
        range.end = end;
      }
      return range;
    }
    return null;
  }
  function stringifyDateRange(range) {
    if (range && (range.start || range.end)) {
      var str = '';
      if (range.start) {
        str += range.start;
      }
      if (range.end) {
        str += `~${range.end}`;
      }
      return str;
    } else {
      return null;
    }
  }
  function parseBookParams(query) {
    var _query$get;
    return {
      date: parseDateRange(query.get('date')),
      guests: parseInteger(query.get('guests')),
      currency: (_query$get = query.get('currency')) !== null && _query$get !== void 0 ? _query$get : GA.currency()
    };
  }
  function slideTo(target) {
    var el;
    if (target instanceof Event) {
      if (target.currentTarget instanceof HTMLAnchorElement && target.currentTarget.hash) {
        target.preventDefault();
        el = document.querySelector(target.currentTarget.hash);
      }
    } else if (target instanceof HTMLElement) {
      el = target;
    }
    if (el) {
      GA.header.toggle(false);
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      setTimeout(() => GA.header.toggle(true), 100);
    }
  }
  async function getJSON(url) {
    var res = await fetch(url, {
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json'
      }
    });
    if (res.ok) {
      return await res.json();
    } else {
      var error = await res.json();
      throw error;
    }
  }
  async function postJSON(url, data) {
    var res = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    if (res.ok) {
      return await res.json();
    } else {
      var error = await res.json();
      throw error;
    }
  }
});//# sourceMappingURL=common.js.map
;
